import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function FooterSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cómo recibo los libros después de comprar?',
    a: 'Una vez realizado el pago, recibirás un correo electrónico inmediatamente con los enlaces para descargar todos los libros y bonos en formato PDF.'
  }, {
    q: '¿Puedo imprimir los cuadernillos?',
    a: '¡Sí! Los archivos están diseñados en alta calidad para que puedas imprimirlos en casa o en una gráfica si preferís tenerlos en formato físico.'
  }, {
    q: '¿Puedo verlos desde mi celular o necesito computadora?',
    a: 'Podés verlos desde cualquier dispositivo: celular, tablet o computadora. Son archivos PDF universales.'
  }, {
    q: '¿Puedo regalar el pack a otra persona?',
    a: '¡Por supuesto! Es un regalo hermoso. Solo tenés que reenviarle el correo con los enlaces de descarga a la persona que quieras.'
  }, {
    q: '¿Cuánto tarda en llegar el pack después de pagar?',
    a: 'La entrega es automática e inmediata. Ni bien se confirma el pago, el sistema te envía el acceso.'
  }, {
    q: '¿Qué incluye exactamente el Pack 100 Citas Familiares?',
    a: 'Incluye 4 libros principales (Mamá e Hija, Mamá e Hijo, Papá e Hija, Papá e Hijo) más 7 bonos exclusivos de regalo.'
  }, {
    q: '¿Es una compra segura?',
    a: '100% segura. Procesamos los pagos a través de plataformas líderes a nivel mundial que protegen todos tus datos.'
  }];
  return <footer className="bg-gray-900 text-gray-400 pt-16 pb-8 px-4 border-t border-gray-800" data-id="element-49">
      <div className="max-w-3xl mx-auto" data-id="element-50">
        {/* FAQ Section */}
        <div className="mb-16" data-id="element-51">
          <div className="text-center mb-10" data-id="element-52">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-53">
              Resolvé aquí tus DUDAS
            </h2>
            <p className="text-gray-400" data-id="element-54">
              Hacé clic para ver la respuesta que necesites.
            </p>
          </div>

          <div className="space-y-4" data-id="element-55">
            {faqs.map((faq, idx) => <div key={idx} className="bg-gray-800 rounded-lg border border-gray-700 overflow-hidden" data-id="element-56">
                <button onClick={() => setOpenFaq(openFaq === idx ? null : idx)} className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" data-id="element-57">
                  <span className="font-bold text-white pr-4" data-id="element-58">{faq.q}</span>
                  {openFaq === idx ? <ChevronUpIcon className="w-5 h-5 text-yellow-400 flex-shrink-0" data-id="element-59" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-60" />}
                </button>
                {openFaq === idx && <div className="px-6 pb-4 text-gray-300" data-id="element-61">
                    <p data-id="element-62">{faq.a}</p>
                  </div>}
              </div>)}
          </div>
        </div>

        {/* Copyright & Links */}
        <div className="text-center text-sm space-y-4 border-t border-gray-800 pt-8" data-id="element-63">
          <p data-id="element-64">Copyright 2025 - Todos los derechos reservados.</p>
          <div className="flex justify-center gap-4" data-id="element-65">
            <a href="#" className="hover:text-white transition-colors" data-id="element-66">
              Privacidad
            </a>
            <span data-id="element-67">|</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-68">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}